import {ClientResponse, hc} from 'hono/client';
import {AppRouter} from './routers/_app';

const client = hc<AppRouter>('/api');

export {client, type ClientResponse};
